export enum ResponseType {
  INVALID_CREDENTIALS = '2',
  SSO_UNAVAILABLE = '55',
  LOGIN_FAILED = '1',
}
